<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido(data-aos="flip-up")
      .titulo-principal__numero
        span 4
      h1 Comunicación asertiva

    figure
      img(src='@/assets/curso/tema4/1.png', alt='', style="width: 1220px").m-auto

    p.mt-4 La comunicación asertiva es una forma de expresión que permite a las personas manifestar sus ideas, opiniones, sentimientos y necesidades de manera clara, respetuosa y honesta, sin afectar los derechos o la dignidad de los demás. Este tipo de comunicación se basa en el equilibrio entre la expresión personal y el respeto por las otras personas, lo que facilita la construcción de relaciones interpersonales basadas en la confianza y la comprensión mutua. A través de la comunicación asertiva, las personas pueden expresar lo que piensan y sienten de forma adecuada, evitando actitudes agresivas o pasivas que pueden generar conflictos o malentendidos.


    .row.align-items-center.mt-4
      .col-lg-4.d-none.d-lg-block
        figure
          img(src='@/assets/curso/tema4/2.png', alt='', style="width: 390px").m-auto
      .col-lg-8
        .row.align-items-start.mt-4
          .col-lg-2.mb-lg-0.mb-4
            figure(data-aos="fade-down")
              img(src='@/assets/curso/tema4/3.svg', style='width: 80px').m-auto
          
          .col
            p Además, la comunicación asertiva favorece el desarrollo de habilidades sociales importantes para la convivencia y el trabajo en equipo. Cuando una persona se comunica de manera asertiva, es capaz de escuchar activamente, expresar sus puntos de vista con claridad y comprender las opiniones de los demás. Esta forma de comunicación contribuye a fortalecer el respeto, la empatía y la cooperación en diferentes contextos sociales y laborales, lo que permite resolver desacuerdos de manera constructiva y promover ambientes de interacción más positivos.

        .row.justify-content-center
          .col-lg-12
            .row.align-items-center
              .col-lg-12
                .cajon.color3.p-4
                  p Por esta razón, desarrollar la comunicación asertiva implica aprender a expresar ideas y emociones con seguridad, mantener una actitud abierta al diálogo y buscar soluciones que beneficien a todas las personas involucradas. Practicar este tipo de comunicación permite mejorar la calidad de las relaciones interpersonales, prevenir conflictos innecesarios y fortalecer la capacidad para interactuar de manera efectiva en distintos escenarios de la vida cotidiana. De esta manera, la comunicación asertiva se convierte en una herramienta fundamental para el desarrollo de competencias blandas y para la construcción de relaciones basadas en el respeto y la colaboración.



    .row.justify-content-center.mt-4
      .col-lg-10
        p Para fortalecer la comunicación asertiva, en la tabla 5 se puede reconocer algunos comportamientos y actitudes que facilitan la expresión clara de ideas y sentimientos, así como el respeto por las opiniones de los demás. La comunicación asertiva no solo implica decir lo que se piensa, sino hacerlo de una manera adecuada, considerando el contexto y las personas con quienes se interactúa. En la siguiente tabla se presentan algunas características de la comunicación asertiva y su importancia en las relaciones interpersonales.

        .titulo-sexto.color-acento-contenido.mb-3.mt-4
          h5 Tabla 5.
          span Características de la comunicación asertiva

        .tabla-a.color-acento-contenido
          table
            thead(style="background-color: #A0F7FE")
              tr
                th(style="width: 300px;") Característica
                th Descripción
                th Importancia en la comunicación
            tbody
              tr(style="background-color: #F6F6F6")
                td.text-start #[b Claridad en el mensaje]
                td.text-start Expresar ideas, opiniones y sentimientos de manera directa y comprensible.
                td.text-start Facilita que el receptor entienda el mensaje sin generar confusión.
              tr
                td.text-start #[b Respeto por los demás]
                td.text-start Reconocer y valorar las opiniones y sentimientos de otras personas.
                td.text-start Promueve relaciones basadas en la empatía y el respeto mutuo.

              tr(style="background-color: #F6F6F6")
                td.text-start #[b Escucha activa]
                td.text-start Prestar atención a lo que la otra persona comunica, mostrando interés y comprensión.
                td.text-start Permite mejorar la comprensión del mensaje y fortalecer el diálogo.
              tr
                td.text-start #[b Control emocional]
                td.text-start Mantener la calma y expresar las emociones de forma adecuada durante la comunicación.
                td.text-start Evita conflictos innecesarios y favorece una interacción equilibrada.

              tr(style="background-color: #F6F6F6")
                td.text-start #[b Expresión de opiniones]
                td.text-start Manifestar ideas y puntos de vista con seguridad y respeto.
                td.text-start Favorece la participación y la construcción de acuerdos entre las personas.

    separador
    #t_4_1.titulo-segundo.color-acento-contenido
      h2 4.1 Concepto de comunicación asertiva

    p La comunicación asertiva se refiere a la capacidad de expresar ideas, opiniones, sentimientos y necesidades de manera clara, directa y respetuosa, manteniendo un equilibrio entre la defensa de los propios derechos y el respeto por los derechos de los demás. Este tipo de comunicación permite a las personas manifestar lo que piensan o sienten sin recurrir a actitudes agresivas o pasivas, favoreciendo un diálogo abierto y constructivo. La comunicación asertiva es considerada una habilidad fundamental dentro del desarrollo de las competencias blandas, ya que contribuye a mejorar la interacción social y la convivencia.


    .row.justify-content-center.mt-4
      .col-lg-10
        .row.align-items-center
          .col-lg-12
            .cajon.color1.p-4
              p Desde esta perspectiva, la comunicación asertiva implica desarrollar una actitud de respeto tanto hacia uno mismo como hacia las demás personas. Expresar opiniones o desacuerdos de forma adecuada permite evitar conflictos innecesarios y facilita la búsqueda de soluciones basadas en el diálogo. Además, la comunicación asertiva promueve la claridad en los mensajes y la responsabilidad en la forma en que se transmiten las ideas, lo que fortalece la comprensión mutua entre las personas.



    .bloque-texto-g.bloque-texto-g--inverso.bg-base.p-3.p-sm-4.p-md-5.mt-4
      .bloque-texto-g__img(
        :style="{'background-image': `url(${require('@/assets/curso/tema4/4.png')})`}"
      )
      .bloque-texto-g__texto.p-4
        p.mb-0 En consecuencia, fortalecer la comunicación asertiva contribuye al desarrollo personal y al mejoramiento de las relaciones sociales y laborales. Las personas que se comunican de manera asertiva generan ambientes de confianza, respeto y colaboración, lo que facilita el trabajo en equipo y la resolución de conflictos. Por esta razón, la comunicación asertiva se considera una herramienta clave para promover una interacción positiva y efectiva en los diferentes espacios de la vida cotidiana.

    p.mt-4 La comunicación asertiva requiere el desarrollo de habilidades específicas que permiten interactuar de manera efectiva y respetuosa en diferentes contextos. A continuación, se presentan las habilidades esenciales que fortalecen este tipo de comunicación y favorecen la construcción de relaciones interpersonales más positivas:

    .row.bg-05.mt-4
      .col-12
        .p-5
          .row.align-items-center.p-5
            .tarjeta.bg-9.p-4
              PasosB.color-acento-contenido
                //-Primer Paso
                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema4/5.png', alt='')
                    
                  .col-md-6
                    h4 La escucha activa

                    p Habilidad para prestar atención plena a lo que la otra persona comunica, mostrando interés genuino por comprender su mensaje antes de responder. Su práctica reduce los malentendidos y favorece el diálogo respetuoso en diferentes contextos sociales y laborales.

                //-Segundo Paso
                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema4/6.png', alt='')
                    
                  .col-md-6
                    h4 La empatía

                    p Capacidad para comprender las emociones, perspectivas y experiencias de otras personas, reconociendo su valor dentro de la interacción. Su práctica fortalece la comprensión mutua y contribuye a construir relaciones basadas en el respeto y la consideración.

                //-Tercer Paso
                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema4/7.png', alt='')
                    
                  .col-md-6
                    h4 El control emocional

                    p Habilidad para reconocer y regular las propias emociones durante la comunicación, respondiendo de manera equilibrada frente a diferentes situaciones. Su desarrollo permite evitar reacciones impulsivas y favorece una interacción más consciente y constructiva.
                    
              
                //-Cuarto Paso
                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema4/8.png', alt='')
                    
                  .col-md-6
                    h4 La claridad en el mensaje

                    p Capacidad para expresar ideas, opiniones y sentimientos de manera directa, precisa y comprensible para el interlocutor. Una comunicación clara reduce las ambigüedades y facilita que los mensajes sean interpretados correctamente en distintos contextos.

                //-Cuarto Paso
                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema4/9.png', alt='')
                    
                  .col-md-6
                    h4 El respeto por los demás

                    p Actitud que reconoce el valor y la dignidad de cada persona durante la interacción, aceptando sus diferencias y puntos de vista. Esta habilidad es fundamental para construir ambientes de convivencia basados en la tolerancia y la cooperación.



    p.mt-4 El desarrollo de estas habilidades no ocurre de manera espontánea, sino que requiere práctica, reflexión y compromiso con el propio crecimiento personal. Cada una de ellas se fortalece progresivamente en la medida en que las personas las aplican de manera consciente en sus interacciones cotidianas, tanto en el ámbito personal como en el laboral. En este sentido, la comunicación asertiva se consolida como una competencia blanda esencial que impacta positivamente en la convivencia, el trabajo colaborativo y la construcción de relaciones interpersonales más saludables y productivas.


    separador
    #t_4_2.titulo-segundo.color-acento-contenido
      h2 4.2 Características de la comunicación asertiva

    .row.bg-01.m-30
      .col-12
        .p-5
          .row.align-items-center
            .col-lg-5.d-none.d-lg-block
              figure
                img(src='@/assets/curso/tema4/10.png', alt='', style="width: 480px").m-auto
            .col-lg-7
              p La comunicación asertiva se caracteriza por permitir que las personas expresen sus ideas, emociones y necesidades de manera clara y respetuosa, manteniendo un equilibrio entre la defensa de sus propios derechos y el respeto por los derechos de los demás. Esta forma de comunicación busca evitar comportamientos extremos como la agresividad o la pasividad, promoviendo en cambio una interacción basada en el diálogo, la comprensión y la cooperación. Cuando una persona se comunica de manera asertiva, transmite sus mensajes con seguridad, pero también muestra disposición para escuchar y considerar los puntos de vista de otras personas.

              .row.align-items-start.mt-4
                .col-lg-2.mb-lg-0.mb-4
                  figure(data-aos="fade-down")
                    img(src='@/assets/curso/tema4/11.svg', style='width: 80px').m-auto
                
                .col
                  p A continuación, se presentan las características esenciales que definen la comunicación asertiva y que permiten comprender su importancia en la construcción de relaciones interpersonales más efectivas y respetuosas:



    .row.justify-content-center.mt-4
      .col-lg-8
        AcordionA.mb-5(tipo="a" clase-tarjeta="tarjeta bg-1")
          .tarjeta.clr--pink02.p-4(titulo="La claridad en la expresión de los mensajes")
            .row.align-items-center
              .col-lg-12
                p Las personas que utilizan este tipo de comunicación expresan sus pensamientos y sentimientos de manera directa, evitando ambigüedades o interpretaciones confusas. Esta característica facilita que el receptor comprenda el mensaje con mayor precisión, reduce la posibilidad de malentendidos y orienta las conversaciones hacia la búsqueda de soluciones constructivas.

              
    
          div(titulo="El respeto por las opiniones y emociones de los demás")
            .row.align-items-center
              .col-lg-12
                p La comunicación asertiva implica reconocer que cada persona tiene perspectivas y experiencias diferentes, por lo que el diálogo debe desarrollarse en un ambiente de consideración mutua. Escuchar activamente, evitar interrupciones y valorar las ideas de otros favorece la construcción de relaciones interpersonales más saludables y fortalece la convivencia en los diferentes espacios sociales y laborales.

          div(titulo="El manejo adecuado de las emociones durante la interacción")
            .row.align-items-center
              .col-lg-12
                p Mantener la calma, expresar desacuerdos de forma respetuosa y buscar soluciones constructivas permite abordar situaciones difíciles sin generar conflictos innecesarios. Esta característica contribuye a mejorar la calidad de la comunicación, fortalecer el trabajo en equipo y promover ambientes de interacción basados en el respeto, la confianza y la cooperación.

      .col-lg-4.d-none.d-lg-block
        figure
          img(src='@/assets/curso/tema4/12.png', alt='', style="width: 390px").m-auto



    p.mt-4 En consecuencia, reconocer y aplicar estas características en la comunicación cotidiana contribuye al fortalecimiento de las relaciones interpersonales y al desarrollo de competencias blandas esenciales para la vida personal y laboral. La comunicación asertiva no es una habilidad innata, sino una práctica que se consolida progresivamente cuando las personas asumen el compromiso de expresarse con claridad, escuchar con respeto y gestionar sus emociones de manera consciente en los diferentes contextos de interacción humana.


    separador
    #t_4_3.titulo-segundo.color-acento-contenido
      h2 4.3 Barreras de la comunicación

    p Las barreras de la comunicación son aquellos factores que dificultan o impiden que un mensaje sea transmitido y comprendido de manera adecuada entre las personas. Estas barreras pueden presentarse en diferentes etapas del proceso comunicativo y afectar tanto la forma en que se envía el mensaje como la manera en que es interpretado por el receptor. Cuando existen barreras en la comunicación, es posible que se generen malentendidos, confusiones o interpretaciones incorrectas que afectan la calidad de la interacción entre las personas.

    .row.align-items-center.mt-4
      .col-lg-8
        .row.align-items-start.mt-4
          .col-lg-2.mb-lg-0.mb-4
            figure(data-aos="fade-down")
              img(src='@/assets/curso/tema4/13.svg', style='width: 80px').m-auto
          
          .col
            p Entre las barreras más comunes se encuentran aquellas relacionadas con aspectos personales y emocionales. Las emociones intensas, los prejuicios, las creencias personales o la falta de disposición para escuchar pueden interferir en la forma en que se interpreta un mensaje. Cuando una persona se encuentra alterada emocionalmente o tiene una actitud negativa frente a una conversación, puede interpretar la información de manera distorsionada, lo que dificulta la comprensión mutua y la construcción de acuerdos.


        .row.justify-content-center.mt-2
          .col-lg-12
            .row.align-items-center
              .col-lg-12
                .cajon.color3.p-4
                  p También existen barreras relacionadas con el contexto o el entorno en el que se desarrolla la comunicación. Factores como el ruido, la falta de atención, el uso inadecuado del lenguaje o la ausencia de claridad en los mensajes pueden afectar la efectividad del proceso comunicativo. En muchos casos, estas barreras surgen cuando la información no se expresa de manera clara o cuando el receptor no cuenta con los elementos necesarios para comprender el mensaje.

      .col-lg-4.d-none.d-lg-block
        figure
          img(src='@/assets/curso/tema4/14.svg', alt='', style="width: 380px").m-auto


    .row.mt-4.justify-content-center
      .col-lg-10
        p Por esta razón, reconocer las barreras de la comunicación es un paso importante para mejorar la calidad de las relaciones interpersonales. Identificar los factores que dificultan la comunicación permite implementar estrategias que favorezcan el diálogo, la escucha activa y la claridad en la transmisión de los mensajes. De esta manera, superar las barreras de la comunicación contribuye a fortalecer la convivencia, prevenir conflictos y promover interacciones más efectivas en los diferentes contextos de la vida personal, social y laboral.


    separador
    #t_4_4.titulo-segundo.color-acento-contenido
      h2 4.4 Estrategias para mejorar la comunicación interpersonal

    .bloque-texto-g.color-primario.p-3.p-sm-4.p-md-5
      .bloque-texto-g__img(
        :style="{'background-image': `url(${require('@/assets/curso/tema4/15.png')})`}"
      )
      .bloque-texto-g__texto.p-4
        p.mb-0 Mejorar la comunicación interpersonal implica desarrollar habilidades que permitan expresar ideas, sentimientos y necesidades de manera clara, respetuosa y efectiva. La comunicación interpersonal es un proceso dinámico que requiere la participación de las personas que interactúan, por lo que es fundamental fortalecer actitudes como la disposición al diálogo, la escucha y el respeto por las opiniones de los demás. Cuando las personas aplican estrategias adecuadas de comunicación, es más fácil construir relaciones basadas en la confianza, la cooperación y el entendimiento mutuo.

    p.mt-4 En este contexto, una de las estrategias más importantes para mejorar la comunicación interpersonal es la práctica de la escucha activa. Escuchar activamente significa prestar atención al mensaje que la otra persona está transmitiendo, evitando interrupciones y mostrando interés por comprender su punto de vista. Esta habilidad permite reducir malentendidos y facilita que las conversaciones se desarrollen en un ambiente de respeto y empatía.



    .row.justify-content-center.mt-3
      .col-lg-10
        .row.align-items-center
          .col-lg-12
            .cajon.color1.p-4
              p De igual manera, la claridad en la expresión de ideas constituye otra estrategia fundamental para fortalecer la comunicación. Expresar pensamientos y sentimientos de manera directa y organizada ayuda a que los mensajes sean comprendidos con mayor facilidad. Utilizar un lenguaje adecuado, evitar ambigüedades y adaptar el mensaje al contexto y a las personas con quienes se interactúa contribuye a mejorar la efectividad del proceso comunicativo.



        p.mt-4 Finalmente, la comunicación interpersonal se fortalece cuando las personas desarrollan habilidades para manejar las emociones y resolver conflictos de manera constructiva. Mantener una actitud abierta al diálogo, buscar soluciones conjuntas y respetar las diferencias permite que las relaciones interpersonales se desarrollen de forma más positiva. La aplicación consciente de estas estrategias contribuye al fortalecimiento de la convivencia, al trabajo colaborativo y al desarrollo de competencias blandas en los distintos ámbitos de la vida.

        .row.aling-items-center.mt-4
          .col-lg-5.d-none.d-lg-block
            figure
              img(src='@/assets/curso/tema4/16.png', alt='', style="width: 390px").m-auto
          .col-lg-7
            .row.align-items-start
              .col-lg-2.mb-lg-0.mb-4
                figure(data-aos="fade-down")
                  img(src='@/assets/curso/tema4/17.svg', style='width: 80px').m-auto
              
              .col
                p A continuación, se presentan algunas estrategias que contribuyen a desarrollar una comunicación más efectiva, empática y respetuosa en los diferentes contextos de interacción:

            ol.lista-ol--cuadro
              li 
                .lista-ol--cuadro__vineta
                  span.text-black 1
                p.mb-0 Escuchar atentamente a la otra persona sin interrumpir.
        
              li 
                .lista-ol--cuadro__vineta
                  span.text-black 2
                p.mb-0 Mantener contacto visual durante una conversación.
        
              li 
                .lista-ol--cuadro__vineta
                  span.text-black 3
                p.mb-0 Utilizar un tono de voz adecuado y respetuoso.

              li 
                .lista-ol--cuadro__vineta
                  span.text-black 4
                p.mb-0 Expresar ideas y opiniones de forma clara y directa.

              li 
                .lista-ol--cuadro__vineta
                  span.text-black 5
                p.mb-0 Formular preguntas para comprender mejor el mensaje de la otra persona.


              li 
                .lista-ol--cuadro__vineta
                  span.text-black 6
                p.mb-0 Mostrar empatía frente a las emociones o situaciones de los demás.


              li 
                .lista-ol--cuadro__vineta
                  span.text-black 7
                p.mb-0 Evitar prejuicios o suposiciones antes de comprender el mensaje completo.


              li 
                .lista-ol--cuadro__vineta
                  span.text-black 8
                p.mb-0 Resumir o confirmar lo que se ha entendido durante una conversación.


              li 
                .lista-ol--cuadro__vineta
                  span.text-black 9
                p.mb-0 Mantener una actitud abierta al diálogo y a la retroalimentación.


              li 
                .lista-ol--cuadro__vineta
                  span.text-black 10
                p.mb-0 Buscar soluciones conjuntas cuando se presentan desacuerdos o conflictos.

    p.mt-4 La incorporación progresiva de estas estrategias en la comunicación cotidiana fortalece la capacidad de las personas para interactuar de manera más consciente, respetuosa y efectiva en distintos espacios de convivencia. Aplicarlas de forma constante no solo mejora la calidad del diálogo, sino que también contribuye a prevenir conflictos, consolidar relaciones de confianza y promover ambientes de colaboración y respeto mutuo en la vida personal y laboral.





</template>

<script>
export default {
  name: 'Tema4',
  data: () => ({
    mostrarIndicadorTarjetaAudio: true,
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
